import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from '@mui/material';
import { StyledPaper, Title, Paragraph } from 'components/layouts/SharedStyles';
import { tieredPricingMap } from 'config/configTieredPricing';

export const PaymentExplanation = () => {
  return (
    <StyledPaper>
      <Title>Registration Fees</Title>
      <Paragraph>
        Registration fees will again be on a tiered plan. Please pay the highest tier that you can afford. "Benefactor" covers our expenses and more; "Sustaining" meets our expenses; and "Basic" is below our cost. Paying the highest tier you can afford helps ensure our expenses are covered and camp can happen again next year and the next. The generosity of campers paying as benefactors has enabled us to include many community members who might otherwise be unable to attend. The early bird discount is available through Monday, November 9.
      </Paragraph>

      <PricingTable />

      <Title sx={{mt: 4}}>Cancellations</Title>
      <Paragraph>
        If you must cancel, $25 per person is retained to cover costs. If you cancel after Dec 1, the full fee is retained unless a replacement can be found from the waiting list. No cancellations accepted after Dec 15.  If a health concern comes up before the weekend, contact us directly and we'll work with you.
      </Paragraph>

    </StyledPaper>
  );
}

const PricingTable = () => {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell></TableCell>
            <TableCell align="center">
              <Typography variant="subtitle2">By Nov 9</Typography>
            </TableCell>
            <TableCell align="center">
              <Typography variant="subtitle2">Nov 10 and later</Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.entries(tieredPricingMap).map(([age, data]) => (
            data.options.map(option => (
              <TableRow key={age + option.category}>
                <TableCell>
                  <Typography variant='body1'>
                    {age === 'adult' ? 'Adult' : data.ageLabel} <em>{option.category}</em>
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Typography variant='body1'>{option.early === 0 ? 'No charge' : `$${option.early}`}</Typography>
                </TableCell>
                <TableCell align="center">
                  <Typography variant='body1'>{option.later === 0 ? 'No charge' : `$${option.later}`}</Typography>
                </TableCell>
              </TableRow>
            ))
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
